export interface HelpAdminModuleOption {
  name: string;
  key: string;
}

export const HELP_ADMIN_MODULES: HelpAdminModuleOption[] = [
  { name: 'Leads', key: 'lead_management' },
  { name: 'Project Leads', key: 'lead_project_page' },
  { name: 'Projects Main Page', key: 'projects_main_page' },
  { name: 'Project Page', key: 'project_page' },
  { name: 'Projects Lot Page', key: 'projects_lot_page' },
  { name: 'Dashboard Page', key: 'dashboard_page' },
  { name: 'Contacts Page', key: 'contacts_page' },
  { name: 'Library Page', key: 'library_page' },
  { name: 'Tasks', key: 'tasks' },
];

/** Catalog `module_key` — first refine_reports row (Lead Management). */
export const HELP_DEFAULT_REPORT_MODULE_KEY = 'all';

/**
 * URL path segment for `/help/admin/:segment/...` and `/help/:segment/...`.
 * Lead Management uses catalog key `lead_management`; legacy `leads` maps to the same segment.
 * Other modules match payload keys (e.g. `properties_data`).
 */
export function helpApiUrlModuleSegment(moduleKey: string | undefined | null): string {
  const k = (moduleKey ?? '').trim();
  if (!k) {
    return 'all';
  }
  return k;
}
